import React, { useEffect, useState } from "react";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import {
  ResultContainer,
  DetailContainer,
  ResultBox,
  ResultTop,
  MoreImages,
  DetailListContainer,
  ListItem,
  DetailBox,
  ResultImg,
  ResultDetailed,
  CtaBox,
  ButtonBox,
  TransparentBtnCta,
  FilledBtnCta,
  MatchBox,
  MatchImg,
  MatchDetail,
  TitleContainer,
  MatchTitle,
  MatchList,
  MatchListItem,
  FeatureImg,
  ResultTitled,
  Titled,
  TopTitle,
  TitleIcon,
  ButtonContainer,
} from "../../components/ResultStyles/ResultStyles";
import { useLocation, useHistory } from "react-router-dom";
import { motion } from "framer-motion";
import { pageTransition, transit } from "../../animate";
import TemperamentImg from "../../assets/result-temp.svg";
import SpanImg from "../../assets/result-life-span.svg";
import WeightImg from "../../assets/result-weight.svg";
import ActivityImg from "../../assets/result-activity.svg";
import HealthImg from "../../assets/result-health.svg";
import SheddingImg from "../../assets/result-shedding.svg";

const ResultPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [newData, setNewData] = useState([]);

  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const data = [...location.state.data.data];
      newData.shift();
      setNewData(data);
      console.log(location.state.data.data, "*!@#Location.State***");
      console.log(location.state.range, "*!@#Location.Range***");

      console.log(
        location.state.data.data[0].links[location.state.range.toLowerCase()],
        "***LINKS***"
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, location.state]);

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={pageTransition}
      transition={transit}
    >
      <div>
        <Nav />
        <ResultContainer>
          <TopTitle>Your Results</TopTitle>
          {location.state && location.state.data.data && (
            <ResultTop>
              <DetailContainer>
                <DetailBox>
                  <TitleContainer>
                    <TitleIcon src={TemperamentImg} alt="temperament" />
                    <Titled>Temperament:</Titled>
                  </TitleContainer>
                  <DetailListContainer>
                    <ListItem>
                      {location.state.data.data[0].temperament}
                    </ListItem>
                  </DetailListContainer>
                </DetailBox>
                <DetailBox>
                  <TitleContainer>
                    <TitleIcon src={SpanImg} alt="temperament" />
                    <Titled>Life Span:</Titled>
                  </TitleContainer>

                  <DetailListContainer>
                    <ListItem>{location.state.data.data[0].lifeSpan}</ListItem>
                  </DetailListContainer>
                </DetailBox>
                <DetailBox>
                  <TitleContainer>
                    <TitleIcon src={WeightImg} alt="temperament" />
                    <Titled>Weight:</Titled>
                  </TitleContainer>
                  <DetailListContainer>
                    <ListItem>{location.state.data.data[0].weight}</ListItem>
                  </DetailListContainer>
                </DetailBox>
                <DetailBox>
                  <TitleContainer>
                    <TitleIcon src={ActivityImg} alt="temperament" />
                    <Titled>Activity Level:</Titled>
                  </TitleContainer>

                  <ListItem style={{ listStyle: "none" }}>
                    {location.state.data.data[0].activityLevel}
                  </ListItem>
                </DetailBox>
                <DetailBox>
                  <TitleContainer>
                    <TitleIcon src={HealthImg} alt="temperament" />
                    <Titled>Health:</Titled>
                  </TitleContainer>
                  <ListItem style={{ listStyle: "none" }}>
                    {location.state.data.data[0].health}
                  </ListItem>
                </DetailBox>
                <DetailBox>
                  <TitleContainer>
                    <TitleIcon src={SheddingImg} alt="temperament" />
                    <Titled>Shedding Amount:</Titled>
                  </TitleContainer>
                  <ListItem style={{ listStyle: "none" }}>
                    {location.state.data.data[0].shedding}
                  </ListItem>
                </DetailBox>
              </DetailContainer>
              <ResultBox>
                <ResultImg>
                  <FeatureImg
                    src={`${location.state.data.data[0].imgLarge}`}
                    alt="sample"
                  />
                </ResultImg>
                <CtaBox>
                  <ResultTitled>
                    {location.state.data.data[0].name}
                  </ResultTitled>
                  <ResultDetailed>
                    {location.state.data.data[0].preference}
                  </ResultDetailed>
                  <ButtonBox>
                    <TransparentBtnCta
                      target="_blank"
                      href={location.state.data.data[0].download}
                    >
                      Download Copy
                    </TransparentBtnCta>
                    <FilledBtnCta
                      target="_blank"
                      href={
                        location.state.data.data[0].links[
                          location.state.range.toLowerCase()
                        ]
                      }
                    >
                      Adopt
                    </FilledBtnCta>
                  </ButtonBox>
                </CtaBox>
              </ResultBox>
            </ResultTop>
          )}
          <TopTitle>More Matches</TopTitle>
          <>
            {newData.map((dog, idx) =>
              idx > 0 ? (
                <MatchBox>
                  <MatchImg>
                    <MoreImages src={`${dog.imgSmall}`} />
                  </MatchImg>
                  <MatchDetail>
                    <MatchTitle>{dog.name}</MatchTitle>
                    <MatchList>
                      <MatchListItem>{dog.temperament}</MatchListItem>
                    </MatchList>
                    <ButtonContainer>
                      <TransparentBtnCta
                        target="_blank"
                        href={dog.download}
                        style={{ marginRight: 15 }}
                      >
                        Download Copy
                      </TransparentBtnCta>
                      <FilledBtnCta
                        target="_blank"
                        href={dog.links[location.state.range.toLowerCase()]}
                      >
                        Adopt
                      </FilledBtnCta>
                    </ButtonContainer>
                  </MatchDetail>
                </MatchBox>
              ) : (
                ""
              )
            )}
          </>
        </ResultContainer>
        <Footer />
      </div>
    </motion.div>
  );
};

export default ResultPage;
